module.exports = __webpack_public_path__ + "static/media/arthur-dog.cd7d00fc.jpg";